module.exports = __webpack_public_path__ + "static/media/Atendimento_Finalizado.8fb9303b.svg";